import React, { type FC, type MouseEvent, useState } from 'react';
import { SemanticMobileModal } from './SemanticMobileModal';

export const SemanticControls: FC = () => {
	const [isModalOpen, setIsModalOpen] = useState(false);

	const handleModalOnClose = (e: MouseEvent) => {
		if (e.type === 'click') {
			setIsModalOpen(false);
		}
	};

	return (
		<>
			{isModalOpen && (
				<SemanticMobileModal handleModalOnClose={handleModalOnClose} />
			)}
		</>
	);
};
